import React from 'react';
import {
  SectionArticleShelvesProps,
  SectionDynaimcShelfProps,
  SectionFeaturedShelfProps,
} from './types/SectionArticleShelves.types';
import SectionDynamicShelf from './SectionDynamicShelf';
import SectionFeaturedShelf from './SectionFeaturedShelf';
import { compareArticlesByViewCount } from '../../../../helpers/articleHelpers';

const SectionArticleShelves = ({
  direction,
  articleShelves,
  articles,
  recentlyViewedArticles,
  mostPopularEnabled,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  seoTitle,
  articleIndexSlug,
  handleSaveClick,
  handleSeeAllClick,
}: SectionArticleShelvesProps) => {
  const setupArticleShelves = (
    articleShelves: (SectionFeaturedShelfProps | SectionDynaimcShelfProps)[]
  ) => {
    const updatedArticleShelves: (
      | SectionFeaturedShelfProps
      | SectionDynaimcShelfProps
    )[] = [];

    const rececentlyViewedSlugs = new Set(
      recentlyViewedArticles.map(article => article.slug)
    );

    const mediaArticles = articles
      .filter(article => !rececentlyViewedSlugs.has(article.slug))
      .filter(article => {
        return article.contentType?.isMedia === true;
      })
      .slice(0, 3);

    const mediaSlugs = new Set(mediaArticles.map(article => article.slug));

    const mostPopularArticles = mostPopularEnabled
      ? articles
          .filter(article => !rececentlyViewedSlugs.has(article.slug))
          .filter(article => !mediaSlugs.has(article.slug))
          .sort(compareArticlesByViewCount)
          .slice(0, 3)
      : [];

    const mostPopularSlugs = new Set(
      mostPopularArticles.map(article => article.slug)
    );

    const latestArticles = articles
      .filter(article => !rececentlyViewedSlugs.has(article.slug))
      .filter(article => !mediaSlugs.has(article.slug))
      .filter(article => !mostPopularSlugs.has(article.slug))
      .sort((a, b) => {
        return (
          new Date(b.publishingDate).getTime() -
          new Date(a.publishingDate).getTime()
        );
      })
      .slice(0, 4);

    for (const articleShelf of articleShelves) {
      if (
        articleShelf.__typename === 'ContentfulSectionFeaturedShelf' &&
        articleShelf.articles &&
        articleShelf.articles.length > 0
      ) {
        updatedArticleShelves.push(articleShelf);
      } else if (articleShelf.__typename === 'ContentfulSectionDynamicShelf') {
        switch ((articleShelf as SectionDynaimcShelfProps).type) {
          case 'latest':
            articleShelf.articles = latestArticles;
            (articleShelf as SectionDynaimcShelfProps).displaySeeAllLabel =
              true;
            break;
          case 'most-popular':
            articleShelf.articles = mostPopularArticles;
            (articleShelf as SectionDynaimcShelfProps).displaySeeAllLabel =
              false;
            break;
          case 'recently-viewed':
            articleShelf.articles = recentlyViewedArticles;
            (articleShelf as SectionDynaimcShelfProps).displaySeeAllLabel =
              true;
            break;
          case 'media':
            articleShelf.articles = mediaArticles;
            (articleShelf as SectionDynaimcShelfProps).slidesToShow = 2;
            (articleShelf as SectionDynaimcShelfProps).displaySeeAllLabel =
              true;
            break;
          default:
            articleShelf.articles = [];
            break;
        }

        if (articleShelf.articles && articleShelf.articles.length > 0) {
          updatedArticleShelves.push(articleShelf);
        }
      }
    }
    return updatedArticleShelves;
  };

  let backgroundColor = 'gallery';
  return (
    <div>
      {setupArticleShelves(articleShelves).map(articleShelf => {
        backgroundColor = backgroundColor == 'gallery' ? 'white' : 'gallery';
        return articleShelf.__typename === 'ContentfulSectionDynamicShelf' ? (
          <SectionDynamicShelf
            {...(articleShelf as SectionDynaimcShelfProps)}
            direction={direction}
            backgroundColor={backgroundColor}
            key={articleShelf.id}
            readingTimeMinuteLabel={readingTimeMinuteLabel}
            displaySaveIcon={displaySaveIcon}
            saveLabelText={saveLabelText}
            seoTitle={seoTitle}
            articleIndexSlug={articleIndexSlug}
            handleSaveClick={handleSaveClick}
            handleSeeAllClick={handleSeeAllClick}
          />
        ) : (
          <SectionFeaturedShelf
            {...(articleShelf as SectionFeaturedShelfProps)}
            backgroundColor={backgroundColor}
            key={articleShelf.id}
            readingTimeMinuteLabel={readingTimeMinuteLabel}
            displaySaveIcon={displaySaveIcon}
            saveLabelText={saveLabelText}
            seoTitle={seoTitle}
            articleIndexSlug={articleIndexSlug}
            handleSaveClick={handleSaveClick}
          />
        );
      })}
    </div>
  );
};

export default SectionArticleShelves;
